import { useContext } from 'react';
import { FeatureFlagContext, FeatureFlagContextType } from '../context/feature-flag.context';

const useFeatureFlags = (): FeatureFlagContextType => {
    const featureFlags = useContext(FeatureFlagContext);
    return featureFlags;
};

export default useFeatureFlags;
